import { COLORS } from '~/data/ui/colors';
import { CSSProperties } from 'react';

export const CarTopLabelStyle: CSSProperties = {
  backgroundColor: `${COLORS.primary.light2}`,
  width: 'fit-content',
  padding: '4px 16px',
  borderRadius: '34px 0px 0px 34px',
  color: COLORS.black.dark,
  fontSize: '14px',
  zIndex: 3,
  borderRight: 'unset',
};
